import { css } from '@emotion/react';
import React from 'react';

import Box from '../../Box/Box';
import { ThinkingIndicator as DotsThinkingIndicator } from '../../ThinkingIndicator';
import { Text } from '../../Typography';
import {
  receivedWrapperStyles,
  thinkingRowStyles,
  thinkingTextStyles,
} from '../ChatWidget.styles';

type ThinkingIndicatorProps = {
  thinkingText: React.ReactNode;
};

const ThinkingIndicator = ({ thinkingText }: ThinkingIndicatorProps) => {
  return (
    <Box css={receivedWrapperStyles}>
      <div css={thinkingRowStyles}>
        <div
          css={css`
            width: 42px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          `}
        >
          <DotsThinkingIndicator
            dotCount={4}
            activeColor="var(--color-neutral-700)"
            inactiveColor="var(--color-neutral-300)"
          />
        </div>
        <Text fontWeight="semibold" css={thinkingTextStyles}>
          {thinkingText}
        </Text>
      </div>
    </Box>
  );
};

export default ThinkingIndicator;
